<template>
  <section>
    <div v-show="itinerary.durationDays">
      <div class="label">duration</div>
      <div>{{ t('day', itinerary.durationDays) }} · {{ t('night', itinerary.durationNights) }}</div>
    </div>

    <div v-show="itinerary.projectedTravelDate">
      <div class="label">travel date</div>
      <div>{{ itinerary.projectedTravelDate }}</div>
    </div>

    <div v-show="itinerary.activityLevel">
      <div class="label">activity level</div>
      <div>{{ itinerary.activityLevel }}</div>
    </div>

    <div v-show="itinerary.groupSize">
      <div class="label">group size</div>
      <div>{{ itinerary.groupSize }}</div>
    </div>

    <div v-show="itinerary.modeOfTransportation">
      <div class="label">transportation</div>
      <div>{{ itinerary.modeOfTransportation }}</div>
    </div>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import { useShared } from '@/helpers/vueHelpers.js'

const { t } = useShared()
const {
  data: { itinerary },
} = useItineraryStore()
</script>

<style lang="scss" scoped>
section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px 16px;
}

div {
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
}

.label {
  color: $grey-100;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 8px;
}
</style>

<i18n lang="yaml">
en:
  day: '{count} day | {count} days'
  night: '{count} night | {count} nights'
</i18n>
